import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import PageNotFoundView from './PageNotFoundView'
import SomethingWentWrongView from './SomethingWentWrongView'

export default function RootBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <PageNotFoundView />
    }
  }

  return <SomethingWentWrongView />
}
